
<template>
  <div class="page-content almacen-page">
    <div class="almacen-wrapper">
      <div class="almacen-card">
        <header class="entrada-header">
          <div>
            <p class="almacen-title">Productos a surtir desde almacén</p>
            <p class="almacen-subtitle">
              Consulta los equipos de esta orden y su ubicación actual en almacén antes de finalizar la entrega.
            </p>
          </div>

          <div class="entrada-header__actions">
            <button type="button" class="ios-ghost-button" @click="volver">
              ← Volver a órdenes
            </button>
            <button
              v-if="orden && orden.id_orden"
              type="button"
              class="ios-primary-button"
              @click="verOrden"
            >
              👁 Ver orden
            </button>
          </div>
        </header>

        <section v-if="orden" class="resumen-card">
          <div class="resumen-item">
            <span class="resumen-label">Folio</span>
            <strong>{{ formatoFolio(orden.folio, orden.version || 1) }}</strong>
          </div>
          <div class="resumen-item">
            <span class="resumen-label">Centro</span>
            <strong>{{ orden.centro_nombre || '—' }}</strong>
          </div>
          <div class="resumen-item">
            <span class="resumen-label">Fecha programada</span>
            <strong>{{ formatearFecha(orden.fecha_programada) }}</strong>
          </div>
          <div class="resumen-item">
            <span class="resumen-label">Estatus</span>
            <span class="status-pill" :class="'status-pill--' + (orden.status || 'pendiente')">
              {{ etiquetaStatus(orden.status) }}
            </span>
          </div>
        </section>

        <section>
          <div v-if="cargando" class="estado-centrado">
            <div class="spinner"></div>
            <p>Cargando productos y ubicaciones…</p>
          </div>

          <div v-else-if="error" class="entrada-hint entrada-hint--error">
            {{ error }}
          </div>

          <div v-else-if="!detalles.length" class="entrada-hint">
            Esta orden no tiene productos para surtido.
          </div>

          <div v-else class="tabla-wrapper">
            <table class="tabla-ordenes">
              <thead>
                <tr>
                  <th>Grupo</th>
                  <th>Tipo</th>
                  <th>Producto</th>
                  <th>Serie</th>
                  <th>Ubicación en almacén</th>
                  <th>Estado entrega</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="detalle in detalles" :key="detalle.id_detalle">
                  <td>#{{ detalle.grupo_unidad || '—' }}</td>
                  <td>
                    <span class="tipo-pill" :class="detalle.tipo_unidad === 'principal' ? 'tipo-pill--principal' : 'tipo-pill--complemento'">
                      {{ detalle.tipo_unidad === 'principal' ? 'Principal' : 'Complemento' }}
                    </span>
                  </td>
                  <td>{{ detalle.producto_nombre || '—' }}</td>
                  <td>{{ detalle.numero_serie || 'Sin serie' }}</td>
                  <td>{{ detalle.ubicacion_almacen || 'Sin ubicación asignada' }}</td>
                  <td>
                    <span class="status-pill" :class="detalle.entregado ? 'status-pill--finalizada' : 'status-pill--pendiente'">
                      {{ detalle.entregado ? 'Entregado' : 'Pendiente' }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ListaProductosAlmacenEntrega',
  data() {
    return {
      cargando: false,
      error: '',
      orden: null,
      detalles: [],
    };
  },
  mounted() {
    this.cargar();
  },
  watch: {
    '$route.params.id'() {
      this.cargar();
    },
  },
  methods: {
    async cargar() {
      const id = this.$route.params.id;
      if (!id) {
        this.error = 'No se recibió el identificador de la orden.';
        return;
      }

      this.cargando = true;
      this.error = '';

      try {
        const res = await axios.get(`/api/almacen/ordenes-entrega/productos-almacen/${id}`);
        if (res.data?.status === 'ok') {
          this.orden = res.data.orden || null;
          this.detalles = Array.isArray(res.data.detalles) ? res.data.detalles : [];
        } else {
          this.error = res.data?.message || 'No se pudo cargar la lista de productos.';
        }
      } catch (error) {
        console.error('Error al cargar productos de surtido:', error);
        this.error = 'No se pudo cargar la lista de productos y ubicaciones.';
        this.$toast?.error(this.error);
      } finally {
        this.cargando = false;
      }
    },
    volver() {
      this.$router.push({ name: 'DashboardOrdenesEntrega' });
    },
    verOrden() {
      if (!this.orden?.id_orden) return;
      this.$router.push({ name: 'VerOrdenEntrega', params: { id: this.orden.id_orden } });
    },
    formatoFolio(folio, version = 1) {
      if (!folio && folio !== 0) return 'SIN FOLIO';
      const n = parseInt(folio, 10);
      if (Number.isNaN(n)) return folio;
      const base = 'ENT-' + String(n).padStart(4, '0');
      return !version || version <= 1 ? base : `${base}-${version}`;
    },
    formatearFecha(f) {
      if (!f) return '—';
      const [y, m, d] = String(f).split('-');
      if (!y || !m || !d) return f;
      return `${d}/${m}/${y}`;
    },
    etiquetaStatus(status) {
      switch (status) {
        case 'pendiente': return 'Pendiente';
        case 'en_proceso': return 'En proceso';
        case 'finalizada': return 'Finalizada';
        case 'solicitando_ajuste': return 'Solicitando ajuste';
        default: return status || 'Pendiente';
      }
    },
  },
};
</script>

<style scoped>
.almacen-page {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 1.5rem 1rem;
}

.almacen-wrapper {
  width: 100%;
  max-width: 1180px;
}

.almacen-card {
  border-radius: 1.8rem;
  padding: 1.5rem 1.4rem 1.2rem;
  background: radial-gradient(circle at 0 0, rgba(59, 130, 246, 0.15), transparent 35%), rgba(15, 23, 42, 0.82);
  border: 1px solid rgba(148, 163, 184, 0.18);
  box-shadow: 0 24px 60px rgba(2, 6, 23, 0.35);
  backdrop-filter: blur(18px);
}

.entrada-header {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-start;
  margin-bottom: 1.2rem;
}

.entrada-header__actions {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.almacen-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: #eef6ff;
  margin: 0;
}

.almacen-subtitle {
  margin: 0.35rem 0 0;
  color: rgba(226, 232, 240, 0.78);
}

.resumen-card {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.85rem;
  margin-bottom: 1rem;
}

.resumen-item {
  padding: 0.9rem 1rem;
  border-radius: 1rem;
  background: rgba(15, 23, 42, 0.48);
  border: 1px solid rgba(148, 163, 184, 0.14);
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.resumen-label {
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: rgba(148, 163, 184, 0.9);
}

.tabla-wrapper {
  overflow: auto;
  border-radius: 1.15rem;
  border: 1px solid rgba(148, 163, 184, 0.16);
}

.tabla-ordenes {
  width: 100%;
  border-collapse: collapse;
  min-width: 920px;
}

.tabla-ordenes th,
.tabla-ordenes td {
  padding: 0.85rem 0.9rem;
  text-align: left;
  border-bottom: 1px solid rgba(148, 163, 184, 0.12);
  color: #e5eefc;
  vertical-align: top;
}

.tabla-ordenes th {
  background: rgba(15, 23, 42, 0.72);
  font-size: 0.82rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(191, 219, 254, 0.88);
}

.estado-centrado,
.entrada-hint {
  padding: 2rem 1rem;
  text-align: center;
  color: rgba(226, 232, 240, 0.82);
}

.entrada-hint--error {
  color: #fecaca;
}

.spinner {
  width: 38px;
  height: 38px;
  border-radius: 999px;
  border: 3px solid rgba(191, 219, 254, 0.22);
  border-top-color: rgba(96, 165, 250, 0.95);
  margin: 0 auto 0.7rem;
  animation: spin 0.8s linear infinite;
}

.status-pill,
.tipo-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  padding: 0.28rem 0.7rem;
  font-size: 0.78rem;
  font-weight: 700;
}

.status-pill--pendiente {
  background: rgba(250, 204, 21, 0.18);
  color: #fde68a;
}

.status-pill--en_proceso {
  background: rgba(59, 130, 246, 0.18);
  color: #bfdbfe;
}

.status-pill--finalizada {
  background: rgba(34, 197, 94, 0.18);
  color: #bbf7d0;
}

.status-pill--solicitando_ajuste {
  background: rgba(244, 114, 182, 0.18);
  color: #fbcfe8;
}

.tipo-pill--principal {
  background: rgba(59, 130, 246, 0.18);
  color: #bfdbfe;
}

.tipo-pill--complemento {
  background: rgba(168, 85, 247, 0.18);
  color: #e9d5ff;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 768px) {
  .entrada-header {
    flex-direction: column;
  }

  .entrada-header__actions {
    width: 100%;
  }
}
</style>
